import { render } from "./LoginButtonLink.vue?vue&type=template&id=2a25551e&scoped=true&ts=true"
import script from "./LoginButtonLink.vue?vue&type=script&lang=ts"
export * from "./LoginButtonLink.vue?vue&type=script&lang=ts"

import "./LoginButtonLink.vue?vue&type=style&index=0&id=2a25551e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a25551e"]])

export default __exports__